import React, { useCallback, useMemo } from "react";
import filterModalStyles from "../../filterModal.module.scss";
import { getSiteId } from "@/src/utils/configUtils";
import FilterCheckBox from "@/src/components/FilterCheckBox";
import { useFilterConditionContext, useCommonContext } from "@/src/provider";
import { useTranslation } from "@/src/i18n/client";

const FeatureContent: React.FC = () => {
    const [featureData, featureSelect] = useFilterConditionContext((state) => [
        state.featureData,
        state.featureSelect,
    ]);
    const { host } = useCommonContext();
    const { t } = useTranslation("specialSub");

    const filteredFeatureData = useMemo(() => {
        const site = getSiteId(host || ""); // You need to replace this with actual site logic
        return site === "uk"
            ? featureData.filter((it) => it.val.toLowerCase() !== "bifocal")
            : featureData;
    }, [host, featureData]);

    const onChange = useCallback(
        (id: string) => {
            featureSelect(Number(id));
        },
        [featureSelect],
    );

    return (
        <div
            className={filterModalStyles["filter-content-item"]}
            style={{ display: "block" }}
        >
            {filteredFeatureData.map((val, key) => (
                <div
                    className={filterModalStyles["filter-content-Radio"]}
                    key={val.title}
                >
                    <FilterCheckBox
                        title={`${t(val.title)}`}
                        id={val.id}
                        checked={val.active}
                        onChange={onChange}
                    />
                </div>
            ))}
        </div>
    );
};

export default FeatureContent;
